import {
  isMobile
} from "utils"
class dialogComponentClass {
  constructor(val) {
    this.content = val;
    this.dialogAnimateTypeList = [
      {
        label: "animate__fadeIn",
        value: 1
      },
      {
        label: "cx_animate__zoomIn_dialog",
        value: 2
      },
      {
        label: "cx_animate__leftIn_dialog",
        value: 3
      },
      {
        label: "cx_animate__rightIn_dialog",
        value: 4
      },
      {
        label: "cx_animate__downIn_dialog",
        value: 5
      },
      {
        label: "cx_animate__upIn_dialog",
        value: 6
      },
    ]
  }
  async init() {
    // 现在外层追加编辑页控制弹框显示的按钮
    this.content.$el.style.position = "relative";
    let dialogShowBtn = document.createElement("span");
    this.dialogShowBtn = dialogShowBtn
    dialogShowBtn.className = "dialogShowBtn";
    dialogShowBtn.style.position = "absolute";
    dialogShowBtn.style.top = 0;
    dialogShowBtn.style.right = "-70px";
    dialogShowBtn.style.cursor = "pointer";
    dialogShowBtn.style.color = "#1d4ad4";
    dialogShowBtn.style.fontSize = "14px";
    dialogShowBtn.innerText = "弹框测试";
    this.toogleDialogBind = this.toogleDialog.bind(this)
    if (this.content.isBigScreenPreview()) {
      //预览页中----点击 文本 之后出现弹窗
      this.content.$el.addEventListener("click", this.toogleDialogBind)
    } else {
    //编辑页中----点击 按钮 之后出现弹窗
      if (this.content.$el.getElementsByClassName("dialogShowBtn").length == 0) {
        this.content.$el.append(dialogShowBtn);
      }
      dialogShowBtn.addEventListener("click", this.toogleDialogBind)
    }

  }
  toogleDialog(){
    //先查找是否有弹窗
    let shadowDiv = document.getElementsByClassName('dialog_component_div');
    let fatherDiv = document.getElementById("container_0");
    let closeBtn, iframeBox, dialogBox
    if(shadowDiv.length === 0){
      shadowDiv = ''
      // 创建遮罩层
      shadowDiv = document.createElement("div");
      shadowDiv.style.position = "absolute";
      shadowDiv.setAttribute("id", "dialog" + this.content._uid);
      shadowDiv.setAttribute("class", "dialog_component_div");
      shadowDiv.style.left = 0;
      shadowDiv.style.top = 0;
      shadowDiv.style.right = 0;
      shadowDiv.style.bottom = 0;
      shadowDiv.style.background = this.content.options.dialogBackgroundColor;
      shadowDiv.style.backdropFilter = "blur("+ this.content.options.dialogBackgroundFilter +"px)";
      shadowDiv.style.zIndex = "2";
      shadowDiv.style.display = "none";
      fatherDiv.style.position = "relative";
      // 创建弹框盒子
      dialogBox = document.createElement("div");
      // dialogBox.style.border = "1px solid rgba(0,0,0,0.45)";
      dialogBox.style.backgroundColor = "rgba(0,0,0,1)";
      dialogBox.style.position = "absolute";
      dialogBox.setAttribute("class", "dialog_box");

      // 创建弹框内iframe
      iframeBox = document.createElement("iframe");
      iframeBox.style.width = "100%";
      iframeBox.style.height = "100%";
      iframeBox.style.border = "0";
      iframeBox.setAttribute("class", "dialog_iframe");
      // 创建关闭按钮
      closeBtn = document.createElement("span");
      closeBtn.className = "icon-portal-close";
      closeBtn.setAttribute("id", "close" + this.content._uid);
      closeBtn.style.fontSize = "24px";
      closeBtn.style.color = "#686868";
      closeBtn.style.position = "absolute";
      closeBtn.style.right = "40px";
      closeBtn.style.top = "20px";
      closeBtn.style.cursor = "pointer";
      dialogBox.append(closeBtn);
      dialogBox.append(iframeBox);
      shadowDiv.append(dialogBox);
      if (this.content.isBigScreenPreview()) {
        this.inPreviewPage(dialogBox, iframeBox, shadowDiv, true)
      }else{
        fatherDiv.append(shadowDiv)
      }
    } else {
      //多个弹窗的兼容
      //修改iframe地址
      dialogBox = document.getElementsByClassName("dialog_box")[0]
      iframeBox = document.getElementsByClassName("dialog_iframe")[0]
      shadowDiv = shadowDiv[0]
      closeBtn = shadowDiv.getElementsByClassName("icon-portal-close")[0]
      shadowDiv.style.background = this.content.options.dialogBackgroundColor;
      shadowDiv.style.backdropFilter = "blur("+ this.content.options.dialogBackgroundFilter +"px)";
      this.inPreviewPage(dialogBox, iframeBox, shadowDiv, false)
    }
    if(this.content.options.dialogAnimateType){
      dialogBox.classList.add("animate__animated")
      dialogBox.classList.add(this.dialogAnimateTypeList[this.content.options.dialogAnimateType - 1].label)
      dialogBox.style.setProperty("--animate-duration", this.content.options.dialogAnimateTime + "s")
    }
    shadowDiv.style.display = "block";
    if (!this.content.isBigScreenPreview()) {
      this.inEditerPage()
    }
    this.closeBtn = closeBtn
    this.closeDialogBind = this.closeDialog.bind(this)
    closeBtn.addEventListener("click", this.closeDialogBind)
  }
  inPreviewPage(dialogBox, iframeBox, shadowDiv, type){
    dialogBox.style.width = this.content.options.dialogWidth + "px";
    dialogBox.style.height = this.content.options.dialogHeight + "px";
    if(isMobile()){
      dialogBox.style.width = "100%";
      dialogBox.style.height = "100%";
    }
    let unitStr = "%", isPercent = false
    if(this.content.options.dialogPositionPercent || this.content.options.dialogPositionPercent === undefined){
      dialogBox.style.transform = "translate(-50%,-50%)";
      dialogBox.style.top = (this.content.options.dialogTop || 50) + "%";
      dialogBox.style.left = (this.content.options.dialogLeft || 50) + "%";
      isPercent = true
    }else{
      dialogBox.style.transform = "none";
      dialogBox.style.top = (this.content.options.dialogTop || 50) + "px";
      dialogBox.style.left = (this.content.options.dialogLeft || 50) + "px";
      unitStr = "px"
    }
    if(this.content.options.useSelfQuery){
      window.localStorage.setItem("sameUrlQuery", 1)
      window.localStorage.setItem("pageQuery", this.content.options.content)
    }
    if(iframeBox.src.trim() != this.content.options.iframelinkUrlVal.trim()){
      iframeBox.setAttribute("src", this.content.options.iframelinkUrlVal);
    }else{
      let isSameUrlQuery = window.localStorage.getItem('sameUrlQuery');
      if(isSameUrlQuery){
        // 跨页面传参，同页面弹框传参
        window.localStorage.removeItem("sameUrlQuery")
        iframeBox.setAttribute("src", this.content.options.iframelinkUrlVal);
      }

    }
    if(type){
      document.body.appendChild(shadowDiv);
    }
    if(this.content.options.dialogAnimateType){
      dialogBox.style.setProperty("--animate-top", this.content.options.dialogTop + unitStr)
      dialogBox.style.setProperty("--animate-left", this.content.options.dialogLeft + unitStr)
      if(this.content.options.dialogAnimateType == 2){
        if(isPercent){
          dialogBox.style.setProperty("--animate-transform1", "translate(-50%,-50%) scale(0.5, 0.5)")
          dialogBox.style.setProperty("--animate-transform2", "translate(-50%,-50%) scale(1, 1)")
        }else{
          dialogBox.style.setProperty("--animate-transform1", "scale(0.5, 0.5)")
          dialogBox.style.setProperty("--animate-transform2", "scale(1, 1)")
        }
      }
    }
  }
  inEditerPage(){
    let dialogBox = document.getElementsByClassName("dialog_box")[0]
    let iframeBox = document.getElementsByClassName("dialog_iframe")[0]
    let shadowDiv = document.getElementsByClassName('dialog_component_div')[0];
    this.content.$watch(
        "options.dialogWidth",
        function (n, o) {
          dialogBox.style.width = n + "px"
        },
        { immediate: true }
    )
    this.content.$watch(
        "options.dialogHeight",
        function (n, o) {
          dialogBox.style.height = n + "px"
        },
        { immediate: true }
    )
    this.content.$watch(
        "options.iframelinkUrlVal",
        function (n, o) {
          iframeBox.setAttribute("src", n)
        },
        { immediate: true }
    )
    this.content.$watch(
        "options.dialogPositionPercent",
        function (n, o) {
          if(n){
            dialogBox.style.transform = "translate(-50%,-50%)";
            dialogBox.style.top = this.options.dialogTop + "%";
            dialogBox.style.left = this.options.dialogLeft + "%";
          }else{
            dialogBox.style.transform = "none";
            dialogBox.style.top = this.options.dialogTop + "px";
            dialogBox.style.left = this.options.dialogLeft + "px";
          }
        },
        { immediate: true }
    )
    this.content.$watch(
        "options.dialogLeft",
        function (n, o) {
          if(this.options.dialogPositionPercent){
            dialogBox.style.left = this.options.dialogLeft + "%";
          }else{
            dialogBox.style.left = this.options.dialogLeft + "px";
          }
        },
        { immediate: true }
    )
    this.content.$watch(
        "options.dialogTop",
        function (n, o) {
          if(this.options.dialogPositionPercent){
            dialogBox.style.top = this.options.dialogTop + "%";
          }else{
            dialogBox.style.top = this.options.dialogTop + "px";
          }
        },
        { immediate: true }
    )
    this.content.$watch(
        "options.dialogBackgroundColor",
        function (n, o) {
          console.log('n',n)
          shadowDiv.style.background = n
        },
        { immediate: true }
    )
    this.content.$watch(
        "options.dialogBackgroundFilter",
        function (n, o) {
          shadowDiv.style.backdropFilter = "blur("+ n +"px)";
        },
        { immediate: true }
    )
  }
  closeDialog() {
    const shadowDiv = document.getElementsByClassName('dialog_component_div')[0];
    shadowDiv.style.display = "none"
    const iframeBox = document.getElementsByClassName("dialog_iframe")[0]
    if(!this.content.options.hasOwnProperty("dialogAnimateType")){
      iframeBox.setAttribute("src", "")
    }
  }
  removeEventTrigger() {
    if (this.content.isBigScreenPreview()) {
      //预览页中----点击 文本 之后出现弹窗
      this.content.$el.removeEventListener("click", this.toogleDialogBind)
    } else {
      this.dialogShowBtn?.removeEventListener("click", this.toogleDialogBind)
    }
    this.closeBtn?.removeEventListener("click", this.closeDialogBind)
  }
}
export default {
  data() {
    return {
      dialogComponentData: new dialogComponentClass(this)
    }
  },
  methods: {
    async dialogComponent() {
      await this.dialogComponentData.init()
    }
  },
  beforeDestroy() {
    this.dialogComponentData.removeEventTrigger()
  }
}
